export default __webpack_public_path__ + "static/media/gallery_02.e3c842d0.jpg";